/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Duplicate_Document_UploadInputs */

const en_api_error_duplicate_document_upload = /** @type {(inputs: Api_Error_Duplicate_Document_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate document upload.`)
};

const pt_br2_api_error_duplicate_document_upload = /** @type {(inputs: Api_Error_Duplicate_Document_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload de documento duplicado.`)
};

/**
* | output |
* | --- |
* | "Duplicate document upload." |
*
* @param {Api_Error_Duplicate_Document_UploadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_duplicate_document_upload = /** @type {((inputs?: Api_Error_Duplicate_Document_UploadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Duplicate_Document_UploadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_duplicate_document_upload(inputs)
	return pt_br2_api_error_duplicate_document_upload(inputs)
});